import { DateTime } from 'luxon'

type ZeroOrOne = '0' | '1'
type ZeroToThree = ZeroOrOne | '2' | '3'
type ZeroToFive = ZeroToThree | '4' | '5'
type Digit = ZeroToFive | '6' | '7' | '8' | '9'

type PaddedBelow20 = `${ZeroOrOne}${Digit}`
type HoursFrom20 = `2${ZeroToThree}`
type Hours = PaddedBelow20 | HoursFrom20

type MinutesOrSeconds = `${ZeroToFive}${Digit}`
export type TimeCodeFormat = `${Hours}:${MinutesOrSeconds}:${MinutesOrSeconds}`

export function getTimeStringFromDate(date: Date): TimeCodeFormat {
  // date.toUTCString() return format: 'Thu, 17 Jun 2021 14:54:46 GMT'
  const [, , , , time] = date.toUTCString().split(' ') as [
    _weekDayWithComma: string,
    _day: string,
    _shortMonth: string,
    _year: string,
    time: TimeCodeFormat,
    _timezone: string,
  ]
  return time
}

type DigitWithoutZero = Exclude<Digit, '0'>

type Padded1to9 = `0${DigitWithoutZero}`
type Below20 = Padded1to9 | `1${Digit}`
type Below30 = Below20 | `2${Digit}`

type PaddedMonth = Padded1to9 | '10' | '11' | '12'
type PaddedDay = Below30 | `3${ZeroOrOne}`
type FullYear = `20${ZeroToFive}${Digit}` // Limited to Y2k and above because who needs the past anyways? 😏
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type UsDateFormat = `${PaddedMonth}/${PaddedDay}/${FullYear}`

type IsoDate = `${FullYear}-${PaddedMonth}-${PaddedDay}`

/**
 * Returns UTC string date in format '%Y-%m-%d %H:%M:%S'
 */
export function formatAsDateAndTime(date: Date): `${string} ${TimeCodeFormat}` {
  const [fullDate, time] = date.toISOString().split('T') as [IsoDate, string]
  const [fullTime] = time.split('.') as [TimeCodeFormat]
  // Trying to use type of `${IsoDate} ${TimeCodeFormat}` is a type union which
  // is too much for TS to handle, so we're forced to use a more simple type here.
  return `${fullDate as string} ${fullTime}`
}

export function dateAsInputString(date: Date): string {
  return date.toISOString().split('T').at(0) as string
}

export function getDateFromString(str: string): Date {
  if (!str) {
    return new Date('invalid date')
  }
  const [maybeDateString] = str.split(' ')
  if (!maybeDateString) {
    return new Date('invalid date')
  }
  const [year, month, day] = maybeDateString.split('-').map(Number) as [number, number, number]
  return new Date(Date.UTC(year, month - 1, day))
}

export function getFormattedDateTimeInUserLocaleAndUTC(date: Date): string {
  return date.toLocaleString([], {timeZone: 'UTC'})
}

export function getFormattedDateInUserLocaleAndUTC(date: Date): string {
  return date.toLocaleDateString([], {timeZone: 'UTC'})
}

export function parseBackendUtcDateString(str: string): Date {
  return DateTime.fromISO(str, {zone: 'UTC'}).toJSDate()
}

export const startOfDayXDaysAgo = (days_ago: number): Date => {
  const res = new Date()
  res.setDate(res.getDate() - days_ago)
  res.setHours(0, 0, 0)
  return res
}
